import React from "react";
import { Pets } from "@mui/icons-material";
import { Chip } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { CHIP_MIN_WIDTH } from "../../enums/Styles";

const StyledChip = styled(Chip)(({ theme, mb }) => ({
  marginBottom: mb || 20,
  justifyContent: "start",
  minWidth: CHIP_MIN_WIDTH,
}));

export default function ChipTitle({
  title = "Chip",
  icon = <Pets />,
  color = "default",
  mb,
}) {
  const { t } = useTranslation();
  return <StyledChip label={t(title)} icon={icon} color={color} mb={mb} />;
}
